module.exports = __webpack_public_path__ + "quotezone-ui/img/top-bottom-white.09340a2b.png";